import React, { useState } from "react";
import axios from "../../../../../Global/axios";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";

const VisaUpdateForm = ({setOpenVisaUpdate,openVisaUpdate,setUpdateVrfData}) => {
  const [sumbmitLoading, setSubmitLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    const VrfId = openVisaUpdate.vrfId;
    const body = {
      status: "update_visa_quantity",
    };
      try {
        const response = await axios.post(
          `/dashboard/gr-visa-vrf/status-update/${VrfId}`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          setSubmitLoading(false);
          dispatch(
            setAppError({ msg: response.data.message, color: "bg-green-600" })
          );
          setOpenVisaUpdate({ open: false, vrfId: "" });
          setUpdateVrfData((prev) => !prev);
        }
      } catch (e) {
        setSubmitLoading(false);
        dispatch(setAppError({ msg: e.response.data.message }));
      }
  };
  return (
    <form
      onSubmit={submitHandler}
      className={`fixed z-50 top-0 uppercase left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        openVisaUpdate ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-2xl w-full uppercase h-auto  min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col">
        <h2 className="text-2xl p-4 pb-1 text-center">VISA GOV Process</h2>

        <p className="text-center mt-5">Update Visa Quantity</p>

        <div className="flex gap-3 min-w-fit m-5">
          <button
            className="p-1 w-20 uppercase rounded-md ring-1 ring-slate-600"
            onClick={() => {
              setOpenVisaUpdate(false);
            }}
          >
            NO
          </button>
          <button
            type="submit"
            className="p-1 w-20 uppercase rounded-md ring-1 ring-red text-white bg-red"
          >
            {sumbmitLoading ? "Submiting.." : "YES"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default VisaUpdateForm;
